import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, ShoppingBag } from 'lucide-react';
const notifications = [{
  flagCode: 'us',
  countryName: 'United States',
  location: 'Chicago, IL',
  name: 'Sarah Jenkins',
  initials: 'SJ',
  time: '5 minutes ago'
}, {
  flagCode: 'us',
  countryName: 'United States',
  location: 'Miami, FL',
  name: 'David Smith',
  initials: 'DS',
  time: '12 minutes ago'
}, {
  flagCode: 'us',
  countryName: 'United States',
  location: 'Houston, TX',
  name: 'Emily Chen',
  initials: 'EC',
  time: '18 minutes ago'
}, {
  flagCode: 'us',
  countryName: 'United States',
  location: 'Los Angeles, CA',
  name: 'Michael Brown',
  initials: 'MB',
  time: '27 minutes ago'
}, {
  flagCode: 'us',
  countryName: 'United States',
  location: 'Boston, MA',
  name: 'Jessica Walsh',
  initials: 'JW',
  time: '41 minutes ago'
}];
export function PurchaseNotifications() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);
  useEffect(() => {
    if (isDismissed) return;
    const initialTimer = setTimeout(() => {
      setIsVisible(true);
    }, 3000);
    return () => clearTimeout(initialTimer);
  }, [isDismissed]);
  useEffect(() => {
    if (isDismissed || !isVisible) return;
    const hideTimer = setTimeout(() => {
      setIsVisible(false);
      setTimeout(() => {
        if (!isDismissed) {
          setCurrentIndex(prev => (prev + 1) % notifications.length);
          setIsVisible(true);
        }
      }, 1500);
    }, 5000);
    return () => clearTimeout(hideTimer);
  }, [isVisible, isDismissed, currentIndex]);
  if (isDismissed) return null;
  const current = notifications[currentIndex];
  return <div className="fixed bottom-4 left-1/2 -translate-x-1/2 z-50 pointer-events-none w-full px-4 flex justify-center" data-id="element-225" data-mp="3j9naaz17px4l">
      <AnimatePresence mode="wait" data-id="element-226" data-mp="3kq9hxr8y0nnh">
        {isVisible && <motion.div key={currentIndex} initial={{
        opacity: 0,
        y: 50,
        scale: 0.9
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 20,
        scale: 0.9
      }} transition={{
        type: 'spring',
        stiffness: 300,
        damping: 25
      }} className="bg-navy-card border border-gold/30 rounded-xl p-3.5 shadow-[0_4px_30px_rgba(212,175,55,0.25)] w-full max-w-[360px] pointer-events-auto relative" data-id="element-227" data-mp="3koybfjo451so">
            <button onClick={() => setIsDismissed(true)} className="absolute top-2 right-2 text-gray-500 hover:text-white transition-colors" aria-label="Close" data-id="element-228" data-mp="2wz3zr5fj5ja0">
              <X size={14} data-id="element-229" data-mp="2n4vd2yd6kkjr" />
            </button>

            <div className="flex items-center gap-3" data-id="element-230" data-mp="24fjfidvnzq7q">
              <div className="relative shrink-0" data-id="element-231" data-mp="1zfnd2j2m86ua">
                <div className="w-11 h-11 rounded-full bg-gold-gradient flex items-center justify-center text-black font-bold text-sm" data-id="element-232" data-mp="1zgynh1qkgcud">
                  {current.initials}
                </div>
                <img src={`https://flagcdn.com/w40/${current.flagCode}.png`} alt={`Flag of ${current.countryName}`} className="absolute -bottom-1 -right-1 w-5 h-5 rounded-full object-cover border-2 border-navy-card shadow" data-id="element-233" data-mp="28fk6sz3v3vw7" />
              </div>

              <div className="flex-1 min-w-0 pr-4" data-id="element-234" data-mp="2w54pdgw3sr4y">
                <div className="flex items-center gap-1.5 text-[11px] text-gray-400 mb-0.5" data-id="element-235" data-mp="2s3sxt5to5vu4">
                  <img src={`https://flagcdn.com/w20/${current.flagCode}.png`} alt="" className="w-4 h-3 rounded-sm object-cover" data-id="element-236" data-mp="363u6h7g6e7k5" />
                  <span className="truncate" data-id="element-237" data-mp="3l7x14ep4tcyv">{current.location}</span>
                </div>

                <p className="text-white text-[13px] leading-snug" data-id="element-238" data-mp="3p874rkpgbrak">
                  <span className="font-bold" data-id="element-239" data-mp="3p6cj246cvv5f">{current.name}</span>{' '}
                  <span className="text-gray-300" data-id="element-240" data-mp="3tzyy22zzsb4e">
                    purchased Spanish Teacher Ready™
                  </span>
                </p>

                <div className="flex items-center gap-1.5 text-[10px] text-green-400 font-medium mt-1" data-id="element-241" data-mp="328j39loa7i33">
                  <span className="w-1.5 h-1.5 rounded-full bg-green-400 animate-pulse" data-id="element-242" data-mp="369bbqcpbxiyb"></span>
                  <ShoppingBag size={10} data-id="element-243" data-mp="3b97kep8z1yk7" />
                  <span data-id="element-244" data-mp="3b7cvkzukxmau">Verified purchase • {current.time}</span>
                </div>
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}